// src/components/test/TestCategoryHeader.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { FiPlus } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

export default function TestCategoryHeader() {
  const { id: testId } = useParams();
  const [myPermissions, setMyPermissions] = useState([]);

  const lang = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = (key, def) => translations[key] || def;

  useEffect(() => {
    fetchMyPermissions();
  }, []);

  const fetchMyPermissions = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const resp = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/my-permissions`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const perms = resp.data?.permissions;
      setMyPermissions(Array.isArray(perms) ? perms : []);
    } catch (err) {
      console.error("❌ Permission bilgileri çekilemedi:", err);
      setMyPermissions([]);
    }
  };

  // Burada module_key'i projenize göre ayarlayın (örneğin "tests")
  const testModule = myPermissions.find(p => p.module_key === "static_admin_accounts");
  const canCreate = testModule?.create_permission || testModule?.full_access;

  return (
    <>
      <ToastContainer />
      <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
        {canCreate && (
          <Link
            to={`/test/${testId}/category/create`}
            className="btn btn-primary"
          >
            <FiPlus size={16} className="me-2" />
            {t("ADD_CATEGORY", "Yeni Kayıt")}
          </Link>
        )}
      </div>
      {/* Eğer ihtiyaç varsa buraya test bazlı ek göstergeler/istatistikler ekleyebilirsiniz */}
    </>
  );
}
